// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1HL64gTNKr5pbdUa5n9_1Y{text-underline-offset:.3rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"underlineOffset": "_1HL64gTNKr5pbdUa5n9_1Y"
};
module.exports = ___CSS_LOADER_EXPORT___;
